// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"346":"7895c7e7","432":"befe56fa"}[chunkId] + ".chunk.css";
};